import { Injectable } from '@angular/core';
import { Hospital, Topic } from '@nsk-app/models';
import { differenceInCalendarDays, differenceInDays } from 'date-fns';
import { Observable, Subject } from 'rxjs';
import { Preferences} from '@capacitor/preferences';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {

  public operationDate: string;
  public topic: Topic;
  public hospital: Hospital;
  public hasDatabase: Date | null;
  public pushEnabled: boolean;

  private dateChangedSubject = new Subject<Date>();

  constructor(
  ) { }

  public get dataChangedObservable(): Observable<Date> {
    return this.dateChangedSubject;
  }

  public async initializeConfiguration(){
    await this.loadConfiguration();
  }

  public async loadConfiguration() {

    this.operationDate = JSON.parse((await Preferences.get({key: 'operation_date'})).value);
    this.topic = JSON.parse((await Preferences.get({key: 'topic'})).value);
    this.hospital = JSON.parse((await Preferences.get({key: 'hospital'})).value);

    const date = JSON.parse((await Preferences.get({key: 'has_database'})).value);
    this.hasDatabase = (date == null ? null : new Date(date));


    const push = JSON.parse(((await Preferences.get({key: 'push_enabled'}))).value);
    this.pushEnabled = push == null ? true : push;
  }

  public async saveConfiguration() {
    await Promise.all([
      Preferences.set({key: 'operation_date', value: JSON.stringify(this.operationDate)}),
      Preferences.set({key: 'topic', value: JSON.stringify(this.topic)}),
      Preferences.set({key: 'hospital', value: JSON.stringify(this.hospital)}),
      Preferences.set({key: 'has_database', value: JSON.stringify(this.hasDatabase)}),
      Preferences.set({key: 'push_enabled', value: JSON.stringify(this.pushEnabled)})
    ]);

    this.dateChangedSubject.next(new Date(this.operationDate));
  }

  public get daysUntilOperation(): number {
    const operationDate = new Date(this.operationDate);
    const currentDate = new Date(new Date().toDateString());

    operationDate.setHours(currentDate.getHours());

    return differenceInCalendarDays(currentDate, operationDate);

  }

}
